let url = "/official/product";

export default {
  find: () => window.app.axios.get(url),
  //查询数据
  findAll: (params) => window.app.axios.get(`${url}/all`, { params }),
  //根据ID查询指定数据
  findOne: (id) => window.app.axios.get(`${url}/${id}`),
  // 新增
  insert: (data) => window.app.axios.post(url, data),
  // 编辑
  update: (id, data) => window.app.axios.put(`${url}/${id}`, data),
  //刪除
  delete: (ids) => window.app.axios.delete(url, { data: ids }),
};
